import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import Swal from 'sweetalert2';

import * as FilePond from 'filepond';
import * as FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import * as FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
// Register plugins
FilePond.registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);

import { LoaderService } from '@teem/services/loader.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { StoreServiceService } from '@teem/services/store-service.service';
import { StoreServiceForm } from '@teem/core/model-forms/store-service-form';
import { StoreService } from '@teem/core/models/store-service';
import { store as StoreApi } from '@teem/constants/api';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { messages as i18n } from '@teem/constants/messages';
import { DEFAULT_LOGO } from '@teem/constants/defaults';
import { ServiceAddonForm } from '@teem/app/core/model-forms/service-addon-form';
import { ServiceAddon } from '@teem/app/core/models/service-addon';
import { AddCategoryModalComponent } from '@teem/app/shared/components/add-category-modal/add-category-modal.component';
import { Select2Directive } from '@teem/app/core/directives/select2.directive';

@Component({
  selector: 'add-services',
  templateUrl: './add-services.component.html',
  styleUrls: ['./add-services.component.scss']
})

export class AddServicesComponent implements OnInit {
  @ViewChild('logoFile') myPond: any;
  @ViewChild('newServiceForm') newServiceForm: FormGroupDirective;
  @ViewChild(Select2Directive) select2Directive = null;
  serviceForm: FormGroup;
  submitted: boolean = false;
  serviceCategoriesApi: string = StoreApi.serviceCategories;
  isSubmitted = false;
  basicInfo: any;
  serviceImageUrl: any = "";
  logoFile: any = null;
  logoUrl: any = null;
  defaultLogoUrl: string = DEFAULT_LOGO;
  base64LogoString = [];
  category: any;
  addNewCategoryTitle: string = i18n.product.add_category
  pondOptions = {
    multiple: false,
    // allowRevert: false,
    allowReplace: false,
    allowRemove: true,
    allowImageResize: true,
    allowImagePreview: true,
    imagePreviewMarkupShow:false,
    imageResizeMode: 'cover',
    // labelIdle: `
    // <div style="text-align: center">
    // 	<p>${i18n.drag_and_drop_file}</p>
    // </div>`,
    imageResizeTargetWidth: 170,
    imagePreviewMinHeight: 200,
    imagePreviewHeight: 200,
    imagePreviewMaxHeight: 200,
    imageResizeTargetHeight: 200,
    // server: this.uploadToServer,
    acceptedFileTypes: 'image/png, image/jpeg, image/gif',
    labelIdle: `<span class="icon-upload"></span>`,
    maxFileSize: '500KB',
    beforeRemoveFile: this.pondHandleRemoveFile,
  };


  formData = new FormData();

  

  constructor(
    public activeModal: NgbActiveModal,
    private el: ElementRef,
    private fb: FormBuilder,
    private loaderService: LoaderService,
    private storeService: StoreServiceService,
    private sharedDataService: SharedDataService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit(): void {
    this.loadCommonData();
    this.basicInfo = (window as any).userInfo;
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        this.basicInfo = data.userInfo;
      }
    })
    this.serviceForm = this.fb.group(new StoreServiceForm(new StoreService()));
  }

  pondHandleInit() {
    // console.log('FilePond has initialised', this.myPond);
  }

  pondHandleAddFile(event: any) {
    this.base64LogoString = [];

    const file = event.file.file;

    if (file && file?.size <= 512000) {
      const reader = new FileReader();

      reader.onload = this.handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }

  }


  handleReaderLoaded(e) {
    this.base64LogoString.push('data:image/png;base64,' + btoa(e.target.result));
  }

  async pondHandleRemoveFile(event: any) {

    // let confirm = await Swal.fire({
    //   title: i18n.are_you_sure,
    //   text: i18n.setting.you_want_to_delete_logo,
    //   icon: 'info',
    //   showCloseButton: true,
    //   showCancelButton: true,
    //   focusConfirm: false,
    //   confirmButtonText: i18n.yes,
    //   cancelButtonText: i18n.no_cancel_it
    // })
    // if (confirm.isConfirmed) {
    return true
    // }
    // return false;
  }


  loadCommonData() {
    this.storeService.commonData().subscribe((data: any) => {
      this.serviceForm.get('service_number').setValue(data.next_service_number);
    })
  }

  get f() {
    return this.serviceForm.controls;
  }

  get amount() {
    let price = this.serviceForm.controls.price.value;
    let discount = this.serviceForm.controls.discount_percent.value;

    if (discount)
      return price - (price * discount / 100);

    return price;
  }


  submit() {
    this.isSubmitted = true;

    if (this.serviceForm.valid) {
      let fd = this.serviceForm.value;

      if (this.base64LogoString != null) {
        fd.service_image = this.base64LogoString[0];
      }

      this.loaderService.startLoading();
      this.storeService.create(fd).subscribe((res) => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.done, i18n.service.added, 'success');
        this.activeModal.close(res);
      }, (err) => {
        this.loaderService.stopLoading();
        if (err.status === 422) {
          if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
            let validationErrors = err.error.errors;
            Object.keys(validationErrors).forEach((prop) => {
              this.serviceForm.get(prop)?.setErrors({
                serverError: validationErrors[prop]
              })
            })
          }
        }
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
      this.isSubmitted = false;
    }
  }

  get addons(): FormArray {
      return this.serviceForm.get('add_ons') as FormArray;
    }
  
    // Add new addon
    addAddon() {
      const addonGroup = this.fb.group(new ServiceAddonForm(new ServiceAddon()))
      this.addons.push(addonGroup);
    }
  
    // Remove an addon by index
    removeAddon(index: number) {
      this.addons.removeAt(index);
    }

    onChangeClient(value: any) {
      if (value) {
        if (value.id == '__add_new_items__') {
          this.select2Directive.clear();
          const modalRef = this.modalService.open(AddCategoryModalComponent);
          modalRef.componentInstance.type = 'service';
  
          modalRef.result.then(result => {
            this.category = {
              id : result.id,
              name : result.name
            }
            this.serviceForm.get('category_id').setValue(result.id)
          });
        } else {
          this.category = {
            id : value.id,
            name : value.name
          }
        }
      }
    }
}
